<template>
  <v-main>
    <v-toolbar class="bg-color" dark extended flat>
      <v-btn dark icon href="http://presentria.ca/">
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout wrap column pb-2 justify-center>
      <v-flex xs12 sm10 md8>
        <v-flex xs12 d-flex justify-center>
          <v-card class="card--flex-toolbar" style="max-width:750px">
            <v-toolbar flat>
              <v-toolbar-title class="body-2 grey--text">Password Expired</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm8>
                  <v-main class="pt-4 pl-4">
                    <h3 class="headline">Your password has expired</h3>
                    <p class="body-1">You haven't changed your password in a while. We recommend users to change their passwords regularly to improve security.</p>
                    <p class="body-2">An email has been sent to your mailbox at {{ email }}. Please follow the link to change your password.</p>
                    <p class="subtitle-2">If you couldn't receive the email, please contact us at <a href="mailto:enquiry@presentria.com?subject=Password+expiration">enquiry@presentria.com</a>.</p>
                  </v-main>
                  <iframe frameborder="0" height="1" width="1" src="/logout.php"></iframe>
                </v-flex>
                <v-flex xs12 sm4 class="hidden-xs-only pt-3">
                  <v-img contain class="ma-3" src="/assets/key.png"></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-main>
</template>

<script>
  export default {
    props: {
      navigateTo: Function
    },
    data() {
      return {
        email: '',
      };
    },
    methods: {
      goHome() {
        window.location.href = '/instructor';
      },
    },
    mounted() {
      if (this.$route.query.email) {
        this.email = decodeURIComponent(this.$route.query.email) || '';
      }
      if (this.email) {
        this.axios.post('public/passwordExpired', {
          email: this.email,
        }).catch((e) => {
          console.error(e);
        });
      }
    },
  };
</script>
